// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '5e40313e-8d56-46e7-a99c-dc9eae3f807b',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Price_and_Locked_Level_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'f22305c8-5899-4298-9d8e-f5baab8d6f8b',
      type: 'Container',
      runtimeType: null,
      name: 'coinPurchaseGroup',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5e40313e-8d56-46e7-a99c-dc9eae3f807b',
      data: undefined,
      stateByName: {
        'coin-purchase': {
          visible: true
        }
      }
    },
    {
      id: '9d8f2f3a-27b2-4fa5-a4b0-921fd830c118',
      type: 'Container',
      runtimeType: null,
      name: 'lockedGroup',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5e40313e-8d56-46e7-a99c-dc9eae3f807b',
      data: undefined,
      stateByName: {
        'coin-purchase': {
          visible: false
        }
      }
    },
    {
      id: 'bcbc2053-305f-49f5-a196-908fe83c7a50',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -36,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin',
      parent: 'f22305c8-5899-4298-9d8e-f5baab8d6f8b',
      data: undefined,
      stateByName: {}
    },
    {
      id: '37457f4d-10e2-4a09-98bb-dd2b84064122',
      type: 'Text',
      runtimeType: null,
      name: 'coinAmountText',
      className: '',
      x: 13,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '50',
      localize: false,
      maxWidth: 53,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f22305c8-5899-4298-9d8e-f5baab8d6f8b',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fded928b-e4de-469f-a514-560dde383f34',
      type: 'Text',
      runtimeType: null,
      name: 'lockedLevelText',
      className: '',
      x: -13,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lvl 1',
      localize: false,
      maxWidth: 52,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9d8f2f3a-27b2-4fa5-a4b0-921fd830c118',
      data: undefined,
      stateByName: {}
    },
    {
      id: '71a48d1f-cadf-4426-bc96-66ec1f658380',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -28,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Icon',
      parent: '9d8f2f3a-27b2-4fa5-a4b0-921fd830c118',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'coin-purchase',
    'locked'
  ],
  animations: []
} as const;

export class BoosterButtonBottomLayout {
  static raw = raw;
  root: Container;
  coinPurchaseGroup: Container;
  lockedGroup: Container;
  coinAmountText: Text;
  lockedLevelText: Text;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'coin-purchase' | 'locked';
    ModelByName: {
      root: typeof raw['list'][0];
      coinPurchaseGroup: typeof raw['list'][2];
      lockedGroup: typeof raw['list'][3];
      coinAmountText: typeof raw['list'][5];
      lockedLevelText: typeof raw['list'][6];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
